import React from 'react'
import {Header, List} from 'semantic-ui-react'

const DebugMock = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Debug Mock</Header>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Include "x-smocks-inspect: true" header in mock request</List.Item>
        <List.Item>2. You will see a response describing request, response, and what was evaluated</List.Item>
        <List.Item>3. The "req" attribute is the request that the mock engine received</List.Item>
        <List.Item>4. The "res" attribute is the response that the mock engine returned</List.Item>
        <List.Item>5. The "evaluated" attribute is an array of the responses considered prior to selecting the one to
          return</List.Item>
      </List>
    </div>
  )
}

export {DebugMock}

export default DebugMock